import { invertedLanguage, setLanguage } from 'helpers/language'
import useCustomTranslation from 'hooks/useCustomTranslation'
import config from 'const/config'
import { MouseEvent } from 'react'
import Icon from './Icon'
import { StyledButton, StyledSpan } from './LanguageButton.styles'

const LanguageButton = (): JSX.Element => {
  const t = useCustomTranslation()
  return (
    <StyledButton
      type="button"
      data-type="customermenu"
      data-object="button"
      data-reason="espanol"
      className="ensightencustomevent"
      onClick={(event: MouseEvent) => {
        event?.preventDefault()
        setLanguage(invertedLanguage)
        const lasthPath = window.location.pathname
          .split('/')
          .filter(item => item !== '')
          .pop()
        // ensure we get the slash at the end of URL
        const lastSlash = window.location.href.substring(
          window.location.href.length - 1
        )
        // only add the slash at the end with is /cpra
        if (lastSlash === '/' || `/${lasthPath}` !== config.BASENAME)
          window.location.reload()
        else window.location.href = `${window.location.href}/`
      }}
    >
      {Icon('globe')}
      <StyledSpan>{t('button')}</StyledSpan>
    </StyledButton>
  )
}

export default LanguageButton
